import { atomWithReset } from "jotai/utils";
export const progressStepAtom = atomWithReset(false);
